export const checkNetworkConnectionText = "JvwjXc";
export default {checkNetworkConnectionText};